// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '../../../../../../utils/index';

export default css`
  ${(props) =>
    props.isNewPDPEnabled
      ? `
    border: ${props.theme.spacing.ELEM_SPACING.SM} solid
    ${props.theme.colorPalette.gray[300]};
      `
      : ` border-top: ${props.theme.spacing.ELEM_SPACING.XS} solid
    ${props.theme.colorPalette.gray[300]};
    `}

  ${(props) =>
    !props.isPDP
      ? `
          border-bottom: ${props.theme.spacing.ELEM_SPACING.XS} solid
          ${props.theme.colorPalette.gray[300]};
          `
      : ``}

  ${(props) =>
    props.isNewPDPEnabled
      ? `
          border-bottom: ${props.theme.spacing.ELEM_SPACING.XXXS} solid
          ${props.theme.colorPalette.gray[300]};
          `
      : `border-left: 0; border-right : 0;`}

  ${(props) =>
    !props.isBundleProduct
      ? `
            padding: 0 14px;
        `
      : `padding: 0`}

  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => (props.isBundleProduct ? `border: none` : '')};
    ${(props) => props.isNewPDPEnabled && `border:unset;`}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      props.isPDP
        ? `
      border-bottom:0;
      `
        : ``}
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) => (props.isNewPJPPDPRedesignEnabled ? `border: none;` : ``)}
  }
  .button-wrapper {
    cursor: pointer;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0;
    padding: 0;
    text-decoration: underline;
    font-size: 10px;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    border: none;
    background: none;
    outline: none;
  }

  .flex-button-container {
    display: flex;
    justify-content: center;
  }

  .flex-button-wrapper {
    cursor: pointer;
    font-weight: 800;
    font-size: 14px;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    line-height: 19px;
    text-transform: uppercase;
    text-align: center;
    margin: 24px auto 16px;
    padding: 14px 54px;
    outline: none;
    color: ${(props) => props.theme.colorPalette.gray[800]};
    background: ${(props) => props.theme.colors.WHITE};
    border: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
    border-radius: 6px;
    text-decoration: none;
  }

  .part-number-section {
    margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    text-align: right;
  }
  @media ${(props) => props.theme.mediaQuery.desktop} {
    .part-number-section {
      max-width: 510px;
    }
  }

  .pdp-tabs-description {
    min-width: 50%;

    @media ${(props) => props.theme.mediaQuery.large} {
      box-sizing: border-box;
      min-width: 57.41482965931863%;
      padding-right: 32px;
      padding-bottom: 24px;
    }
  }

  .flex-container {
    display: flex;
    justify-content: space-between;
    column-gap: 32px;

    @media ${(props) => props.theme.mediaQuery.smallMax} {
      flex-direction: column;
      max-height: 88px;
      overflow: hidden;
      row-gap: 24px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      column-gap: 0;
      padding: 0 36px;
    }
  }

  .show-description-list {
    display: none;
  }

  .product-detail-footer {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
  .claim-message {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG} 0 7px;

    @media ${(props) => props.theme.mediaQuery.smallMax} {
      ${(props) => props.pdpTabview && 'padding-top: 0;'}
    }
  }

  .short-description {
    line-height: 22px;
  }

  max-height: initial;

  .product-desc-heading {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0;
    ${(props) =>
      !props.isNewPDPEnabled &&
      `background: url(${getIconPath('up_arrow_icon', props)}) no-repeat right 0 bottom 7px;`}
  }

  .show-accordion-toggle {
    ${(props) =>
      !props.isNewPDPEnabled &&
      `background: url(${getIconPath('down_arrow_icon', props)}) no-repeat right 0 bottom 7px;`}
  }
  .common-claim-message {
    padding-top: 0;
  }
  .introduction-text {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      max-height: 90px;
    }
    max-height: 100%;
    overflow: hidden;
    .list-content {
      padding-left: 18px;
      li {
        list-style-type: disc;
        line-height: 22px;
      }
    }
  }

  .show-more-expanded {
    max-height: initial;
    overflow: visible;
  }

  .show-on-mobile {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
    }
  }
  .show-on-desktop {
    display: block;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .product-desc-heading {
      background: none;
    }
    .show-description-list {
      display: block;
    }
    .introduction-text {
      max-height: 100%;
    }
    .show-more-expanded {
      max-height: 100%;
      overflow: visible;
    }
    .button-wrapper {
      border: none;
      outline: none;
    }
    ${(props) =>
      !props.isBundleProduct
        ? `
      border: 1px solid ${props.theme.colorPalette.gray[500]}
      `
        : `border: none`}
    border-left: 0;
    border-right: 0;
  }
`;
